import { render, staticRenderFns } from "./CancelShareTips.vue?vue&type=template&id=27f01fe8"
import script from "./CancelShareTips.vue?vue&type=script&lang=js"
export * from "./CancelShareTips.vue?vue&type=script&lang=js"
import style0 from "./CancelShareTips.vue?vue&type=style&index=0&id=27f01fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports